// ref: https://ponyfoo.com/articles/proposal-draft-for-flatten-and-flatmap

function flatten(list, depth, mapperFn, mapperCtx) {
  if (depth === 0) {
    return list;
  }
  return list.reduce((accumulator, item, i) => {
    if (mapperFn) {
      item = mapperFn.call(mapperCtx || list, item, i, list);
    }
    if (Array.isArray(item)) {
      accumulator.push(...flatten(item, depth - 1));
    } else {
      accumulator.push(item);
    }
    return accumulator;
  }, []);
}

export default function flatMap(array, fn) {
  return flatten(array, Infinity, fn, false);
}



// WEBPACK FOOTER //
// ./src/util/flat-map.js